export const STATE_NAME = "weightIncrease";
export const FORM_NAME = STATE_NAME;
